<template>
    <div class="automation-block-editor records-from-csv">
        <div class="editor-row customize-editor-minimize">
            <CSVRecordsConfiguration v-model="clone" />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import StringUtils from "../../../../../../../utils/StringUtils";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import CSVRecordsConfiguration from "./CSVRecordsConfiguration.vue";

const log = log2("RecordsFromCSV");
export default {
    name: "RecordsFromCSV",
    components: { CSVRecordsConfiguration, CustomPicker, SupsisButton, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            assetId: null,
            mapping: [],
            firstRowContainsHeader: true,
            seperator: ",",
        };
        return {
            clone,
            hashCode: StringUtils.hashCodeObj(clone),
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.hashCode = StringUtils.hashCodeObj(newValue);
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.records-from-csv {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }

    .data-items {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .webhook-data-item {
            border-bottom: 1px solid var(--color-border-default);
            padding-bottom: 3px;
        }
    }
}
</style>
